<template>
    <div class="news-list__app">
        <div v-if="industries.length || categories.length || availableYears.length" class="col-wrapper -max-width-limited">
            <div class="col">
                <div ref="filterform" class="module-filter-form">
                    <div class="filter-form__form form">
                        <div class="form-wrapper -bg-white">
                            <div v-if="industries.length" class="col">
                                <NewsFilter
                                        v-model="selectedIndustries"
                                        :label="$t('filter.industries')"
                                        :options="industries"
                                        identifier="industries"/>
                            </div>
                            <div v-if="categories.length" class="col">
                                <NewsFilter
                                        v-model="selectedCategories"
                                        :label="$t('filter.categories')"
                                        :options="categories"
                                        identifier="categories"/>
                            </div>
                            <div v-if="availableYears.length" class="col">
                                <NewsFilter
                                        :label="$t('filter.year.title')"
                                        :options="availableYears"
                                        :value="[selectedYear]"
                                        identifier="years"
                                        layout="radio"
                                        @input="selectedYear = $event"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedIndustries.length || selectedCategories.length || selectedYear !== null" class="filter-form__selected">
                        <div class="selected__wrapper">
                            <template v-for="industry in industries.filter(item => selectedIndustries.includes(item.uid))"
                                      :key="`industry-selected-${industry.uid}`">
                                <div class="selected__item"
                                     @click="selectedIndustries = selectedIndustries.filter(selected => selected !== industry.uid)">
                                    <span class="icon-times-after">{{ industry.name }}</span>
                                </div>
                            </template>
                            <template
                                    v-for="category in categories.filter(item => selectedCategories.includes(item.uid))"
                                    :key="`category-selected-${category.uid}`">
                                <div class="selected__item"
                                     @click="selectedCategories = selectedCategories.filter(selected => selected !== category.uid)">
                                    <span class="icon-times-after">{{ category.name }}</span>
                                </div>
                            </template>
                            <div v-if="selectedYear !== null" class="selected__item" @click="selectedYear = null">
                                <span class="icon-times-after">{{ availableYears[selectedYear].name }}</span>
                            </div>
                        </div>
                        <div class="selected__reset">
                            <span class="link" @click="reset()"><span>{{ $t('filter.reset') }}</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-wrapper -max-width-limited">
            <div class="col">
                <div class="content-item module-news">
                    <div v-if="!initialized || newsLoading" class="news-wrapper">
                        <template v-for="n in currentPage * itemsPerPage" :key="n">
                            <div class="news__item news__item--loading">
                                <div class="item__image"></div>
                                <div class="item__content">
                                    <div class="content__date"><span></span></div>
                                    <div class="content__headline"><span></span><span></span></div>
                                    <div class="content__text"><span></span><span></span><span></span></div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-else class="news-wrapper">
                        <template v-for="item in news" :key="item.localizedUid">
                            <TypoLink :link="item.link" class="news__item -bg-white">
                                <div class="item__image">
                                    <img v-if="item.image" :alt="item.image.split('|')[2]" :src="item.image.split('|')[0]"
                                         :title="item.image.split('|')[1]">
                                </div>
                                <div class="item__content">
                                    <div class="content__date">
                    <span class="heading zeta -color-grey-light">
                      {{
                            $moment(item.date)
                                    .format(dateFormat)
                        }}
                    </span>
                                    </div>
                                    <div class="content__headline">
                    <span class="heading delta -color-text-alpha">
                      {{ item.name }}
                    </span>
                                    </div>
                                    <div class="content__text">
                                        <p class="meta -color-text-alpha">
                                            {{ item.text }}
                                        </p>
                                    </div>
                                </div>
                            </TypoLink>
                        </template>
                        <div class="news__item news__item--placeholder"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-wrapper -max-width-limited">
            <div class="col">
                <div class="content-item module-load-more">
                    <div v-if="currentPage < numberOfPages" class="load-more__button">
                        <div class="btn -btn-alpha" @click="loadMore">
                            <span>{{ $t('loadMore.btn') }}</span>
                        </div>
                    </div>
                    <div v-if="initialized" class="load-more__progress">
                        <div class="progress__info">
                            <span class="meta" v-html="$t('loadMore.info', { current: news.length, total: numberOfTotalItems })"></span>
                        </div>
                        <div class="progress__bar"><span :style="{ width: (news.length / numberOfTotalItems * 100) + '%' }"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsFilter from '@/components/NewsFilter'
import TypoLink from '@/components/TypoLink'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      dateFormat: window.app.news_list.date_format.replace('%d', 'DD')
        .replace('%m', 'MM')
        .replace('%Y', 'YYYY')
    }
  },
  computed: {
    ...mapState({
      initialized: state => state.initialized,
      availableYears: state => state.news.availableYears,
      industries: state => state.industries.items,
      categories: state => state.categories.items,
      news: state => state.news.items,
      newsLoading: state => !state.news.loaded,
      currentPage: state => state.news.currentPage,
      itemsPerPage: state => state.news.itemsPerPage,
      numberOfPages: state => state.news.numberOfPages,
      numberOfTotalItems: state => state.news.numberOfTotalItems
    }),
    selectedIndustries: {
      get () {
        return this.$store.state.industries.selected
      },
      set (payload) {
        this.$store.commit('industries/setSelected', payload)
        this.filter()
      }
    },
    selectedCategories: {
      get () {
        return this.$store.state.categories.selected
      },
      set (payload) {
        this.$store.commit('categories/setSelected', payload)
        this.filter()
      }
    },
    selectedYear: {
      get () {
        return this.$store.state.news.selectedYear
      },
      set (val) {
        this.$store.state.news.selectedYear = val
        this.filter()
      }
    }
  },
  components: {
    TypoLink,
    NewsFilter
  },
  methods: {
    ...mapActions([
      'init',
      'filter',
      'loadMore'
    ]),
    reset () {
      this.selectedIndustries = []
      this.selectedCategories = []
      this.selectedYear = null
      this.filter()
    }
  },
  created () {
    this.init()
  }
}
</script>
